// This function will import all files from the given context
const requireAll = (requireContext) => requireContext.keys().map(requireContext)

const templates = require.context('../../assets/javascripts/templates', true, /\.hamlc$/)

// Initialize JST global object
window.JST = {}
// Load all templates into the JST object
requireAll(templates).forEach((template) => {
   const fileName = templates.keys().find(key => templates(key) === template).replace('./', '').replace('.hamlc', '')

   window.JST[fileName] = template.default || template
})
